import { RouteType } from "../../../types/RouteType";

const MixDesignApprovalWorkflowRoute: RouteType = {
  name: "Mix Design Approval",
  path: "/workflows/mix-design-approval",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./MixDesignApprovalWorkflowHeader"),
      title: "Approve Mix Design",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./MixDesignApprovalWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default MixDesignApprovalWorkflowRoute;
